


















































































import Vue from 'vue';

import store from '@/store';
import { idGenerator } from '@/utils';

import { BasePacketKind, basePacketKindFromString } from '@/models/packet';
import { WebRequestStatus } from '@/models';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import MultiPointPacketBuilder from '@/components/MultiPointPacketBuilder.vue';
import PacketKindSelector from '@/components/PacketKindSelector.vue';
import PersistableProgress from '@/components/PersistableProgress.vue';
import SinglePointPacketBuilder from '@/components/SinglePointPacketBuilder.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    PacketKindSelector,
    PersistableProgress,
    MultiPointPacketBuilder,
    SinglePointPacketBuilder
  },

  props: {
    organizationId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      stepNo: 1,
      packetKind: BasePacketKind.SINGLE_POINT,
      groupConnectionStatusId: idGenerator.next()
    };
  },

  computed: {
    singlePoint(): boolean {
      return this.packetKind === BasePacketKind.SINGLE_POINT;
    },

    multiPoint(): boolean {
      return !this.singlePoint;
    },

    missingInfo(): boolean {
      return !!this.messages.length;
    },

    createPacketStatus(): WebRequestStatus {
      return this.singlePoint
        ? store.state.singlePoint.packetCreateStatus
        : store.state.multiPoint.packetCreateStatus;
    },

    createBadgesStatus(): WebRequestStatus {
      return this.singlePoint
        ? store.state.singlePoint.badgesCreateStatus
        : store.state.multiPoint.badgesCreateStatus;
    },

    connectGroupStatus(): WebRequestStatus {
      return (
        store.state.org.activeRequests.associate.getStatus(
          this.groupConnectionStatusId
        ) || WebRequestStatus.READY
      );
    },

    hideGroupStatus(): boolean {
      return this.connectGroupStatus === WebRequestStatus.READY;
    },

    messages(): string[] {
      return this.singlePoint
        ? store.getters.singlePoint.messages
        : store.getters.multiPoint.messages;
    }
  },

  methods: {
    previous() {
      this.updateRoute({
        stepNo: `${this.stepNo - 1}`
      });
    },

    buildSinglePoint() {
      this.updateRoute({
        packetKind: BasePacketKind.SINGLE_POINT,
        stepNo: `${this.stepNo + 1}`
      });
    },

    buildMultiPoint() {
      this.updateRoute({
        packetKind: BasePacketKind.MULTI_POINT,
        stepNo: `${this.stepNo + 1}`
      });
    },

    bubbleFindBasePacket() {
      this.$emit('find-base-packet', {});
    },

    async create() {
      this.updateRoute({
        stepNo: `${this.stepNo + 1}`
      });

      await (this.singlePoint
        ? store.dispatch.singlePoint.createPacket(this.organizationId)
        : store.dispatch.multiPoint.createPacket(this.organizationId));

      const createdPacket = this.singlePoint
        ? store.state.singlePoint.packet
        : store.state.multiPoint.packet;

      this.$emit('created', {
        createdPacket,
        statusId: this.groupConnectionStatusId
      });
    },

    updateRoute(update: { stepNo?: string; packetKind?: BasePacketKind }) {
      const { name, params, query } = this.$route;

      this.$router.push({
        name: name ?? undefined,
        params,
        query: {
          ...query,
          ...update
        }
      });
    },

    parseStateFromRoute() {
      const stepNo = +(this.$route.query.stepNo || 1);

      if (stepNo !== this.stepNo) {
        this.stepNo = stepNo;
      }

      const rawPacketKind = (this.$route.query.packetKind ??
        BasePacketKind.SINGLE_POINT) as string;

      const packetKind = basePacketKindFromString(rawPacketKind);

      if (packetKind != this.packetKind) {
        this.packetKind = packetKind;
      }
    }
  },

  watch: {
    $route() {
      this.parseStateFromRoute();
    }
  },

  created() {
    this.parseStateFromRoute();
  }
});
